module.exports = __webpack_public_path__ + "img/25.c8f2d87e.png";